import { render, staticRenderFns } from "./BankRequest.vue?vue&type=template&id=3977f386&scoped=true"
import script from "./BankRequest.vue?vue&type=script&lang=js"
export * from "./BankRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3977f386",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3977f386')) {
      api.createRecord('3977f386', component.options)
    } else {
      api.reload('3977f386', component.options)
    }
    module.hot.accept("./BankRequest.vue?vue&type=template&id=3977f386&scoped=true", function () {
      api.rerender('3977f386', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/cardHandling/components/BankRequest.vue"
export default component.exports